<template>
  <div>
	<div class="main-editor-workspace" :class="{ 'has-context-panel': showMainContextPanel }">
		<div class="main-editor-zone" @click.capture="handleMainEditorZoneClick">
			<v-medium-editor ref="mediumeditor" class="" @change="changed()" :prefill="processedContent" :options="options" />
		</div>

		<div v-if="showMainContextPanel" class="structured-fields-panel main-context-panel">
			<div class="structured-fields-header">
				<div>
					<div class="structured-fields-title">Variables del contexto</div>
					<div class="structured-fields-help">Haz clic en el texto para contextualizar. Inserción directa en el editor.</div>
				</div>
				<div class="main-context-header-right">
					<button
						type="button"
						class="context-debug-toggle"
						:title="showContextDebug ? 'Ocultar debug' : 'Mostrar debug'"
						@click="showContextDebug = !showContextDebug"
					>
						<i class="fa fa-bug"></i>
					</button>
					<div class="main-context-badge">{{ mainContextLabel }}</div>
				</div>
			</div>

			<div v-if="showContextDebug" class="context-debug-panel">
				<div class="context-debug-title">Debug contexto</div>
				<div class="context-debug-row"><strong>Click nodo:</strong> {{ contextDebugInfo.clickedNode || '-' }}</div>
				<div class="context-debug-row"><strong>Click texto:</strong> {{ contextDebugInfo.clickedText || '-' }}</div>
				<div class="context-debug-row"><strong>Ancestro estructurado:</strong> {{ contextDebugInfo.ancestorNode || '-' }}</div>
				<div class="context-debug-row"><strong>data-type:</strong> {{ contextDebugInfo.ancestorType || '-' }}</div>
				<div class="context-debug-row"><strong>data-type-value:</strong> {{ contextDebugInfo.ancestorTypeValue || '-' }}</div>
				<div class="context-debug-row"><strong>Ruta resuelta:</strong> {{ contextDebugInfo.resolvedPath || '-' }}</div>
				<div class="context-debug-row"><strong>Nodos revisados:</strong> {{ (contextDebugInfo.reviewedNodes || []).join(' > ') || '-' }}</div>
				<div class="context-debug-row"><strong>Definición:</strong> {{ contextDebugInfo.definitionName || '-' }}</div>
			</div>

			<div class="structured-fields-body main-context-body">
				<div class="structured-fields-filter-wrap">
					<input
						v-model.trim="mainStructuredFieldsFilter"
						type="text"
						class="structured-fields-filter"
						placeholder="Filtrar variables..."
					/>
				</div>

				<details class="fields-group" open>
					<summary>Campos simples ({{ groupedMainContextOptions.simple.length }})</summary>
					<div class="structured-fields-list">
						<button
							v-for="(option, index) in groupedMainContextOptions.simple"
							:key="`main-simple-${index}-${option.content}`"
							type="button"
							class="structured-field-chip"
							:class="`structured-field-${option.tipo || 'string'}`"
							@click="insertMainEditorOption(option)"
						>
							<span>{{ option.name }}</span>
							<span class="structured-field-kind" :class="`structured-field-kind-${option.tipo || 'string'}`">
								{{ getStructuredOptionTypeLabel(option) }}
							</span>
						</button>
					</div>
				</details>

				<details class="fields-group" open v-if="groupedMainContextOptions.object.length">
					<summary>Objetos ({{ groupedMainContextOptions.object.length }})</summary>
					<div class="structured-fields-list">
						<button
							v-for="(option, index) in groupedMainContextOptions.object"
							:key="`main-object-${index}-${option.content}`"
							type="button"
							class="structured-field-chip structured-field-object"
							@click="insertMainEditorOption(option)"
						>
							<span>{{ option.name }}</span>
							<span class="structured-field-kind" :class="`structured-field-kind-${option.tipo || 'string'}`">
								{{ getStructuredOptionTypeLabel(option) }}
							</span>
						</button>
					</div>
				</details>

				<details class="fields-group" open v-if="groupedMainContextOptions.list.length">
					<summary>Listas / Iteradores ({{ groupedMainContextOptions.list.length }})</summary>
					<div class="structured-fields-list">
						<button
							v-for="(option, index) in groupedMainContextOptions.list"
							:key="`main-list-${index}-${option.content}`"
							type="button"
							class="structured-field-chip structured-field-list"
							@click="insertMainEditorOption(option)"
						>
							<span>{{ option.name }}</span>
							<span class="structured-field-kind" :class="`structured-field-kind-${option.tipo || 'string'}`">
								{{ getStructuredOptionTypeLabel(option) }}
							</span>
						</button>
					</div>
				</details>
			</div>
		</div>
	</div>
	<vue-simple-context-menu
	  :elementId="'vueSimpleContextMenu'"
	  :options="contextMenu_options"
	  :ref="'vueSimpleContextMenu'"
	  @option-clicked="optionClicked"
	/>


	<!-- popup de ediciÃ³n de propiedades del elemento seleccionado -->
	<f7-popup ref="popupEdicion" class="popupedicion" v-if="popupEdicionShow" @popup:close="handlePopupClose" :opened="true">
		<f7-page>
			<f7-navbar>
			<f7-nav-left>
				<f7-link @click="applyChanges">Guardar</f7-link>
			</f7-nav-left>
			<f7-nav-title>Editar</f7-nav-title>
			<f7-nav-right></f7-nav-right>
			</f7-navbar>
			<f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Estilos
							<f7-link @click="addNewStyle" class="icon-button" title="AÃ±adir nuevo estilo CSS">
								<i class="fa fa-plus"></i>
							</f7-link>
						</div>
						<f7-row>
							<f7-col width="50" v-for="(style, index) in objetoActual.properties.style" :key="'style-' + index">
								<div @contextmenu.prevent="showOptions(style, $event)" class="style-item">
									<f7-list-input
										outline
										:label="index"
										floating-label
										type="text"
										:placeholder="index"
										clear-button
										@change="style.valor = $event.target.value"
										:value="style.valor"
									></f7-list-input>
								</div>
							</f7-col>
						</f7-row>
					</f7-list>
				</f7-card-content>
			</f7-card>
			<f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Propiedades
							<f7-link @click="addNewAttribute" class="icon-button" title="AÃ±adir nuevo atributo HTML">
								<i class="fa fa-plus"></i>
							</f7-link>
						</div>
						<f7-row>
							<f7-col width="50" v-for="(attribute, index) in objetoActual.properties.attributes" :key="'attribute-' + index">
								<div @contextmenu.prevent="showOptions(attribute, $event)" class="attribute-item">
									<f7-list-input
										outline
										:label="index"
										floating-label
										type="text"
										:placeholder="index"
										clear-button
										@change="attribute.valor = $event.target.value"
										@contextmenu.prevent="showOptions(attribute, $event)"
										:value="attribute.valor"
									></f7-list-input>
								</div>
							</f7-col>
						</f7-row>
					</f7-list>
				</f7-card-content>
		  	</f7-card>
			<f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Contenido del Tag</div>
						<div style="margin-top: 10px; margin-left: 15px; margin-right: 15px;">
							<textarea
								class="html-editor-textarea"
								placeholder="Edita el contenido HTML del tag seleccionado"
								v-model="objetoActual.html"
								@change="objetoActual.html = $event.target.value"
							></textarea>
							<small style="color: #666; display: block; margin-top: 8px;">Edita el contenido HTML del tag seleccionado</small>
						</div>
					</f7-list>
				</f7-card-content>
			</f7-card>
			<f7-card v-if="objetoActual.properties.innerHTML" class="padding-vertical-half padding-right" style="z-index: 3000; overflow: visible;">
				<f7-card-content>
					<f7-list strong-ios dividers-ios inset-ios>
						<div class="popup-title">Contenido dinÃ¡mico</div>
						<div
							class="structured-workspace"
							:class="{ 'has-panel': hasStructuredInnerHTMLOptions, 'is-resizing': isColumnResizing }"
							:style="structuredWorkspaceStyle"
						>
							<div
								ref="dynamicEditorContainer"
								class="structured-editor-zone"
								@contextmenu.prevent="showOptions(objetoActual.properties.innerHTML, $event)"
								@dragover.prevent
								@drop.prevent="handleDropOnDynamicEditor"
							>
								<vue-editor
									ref="textareaContenidoDinamico"
									:placeholder="'Contenido dinÃ¡mico'"
									v-model="objetoActual.properties.innerHTML.valor"
									:editor-toolbar="customToolbar"
								></vue-editor>
							</div>

							<div
								v-if="hasStructuredInnerHTMLOptions"
								class="structured-column-resizer"
								@mousedown.prevent="startColumnResize"
							></div>

							<div
								v-if="hasStructuredInnerHTMLOptions"
								class="structured-fields-panel inline-structured-panel"
							>
								<div class="structured-fields-header">
									<div>
										<div class="structured-fields-title">Campos disponibles</div>
										<div class="structured-fields-help">Haz clic o arrastra un campo al editor.</div>
									</div>
								</div>

								<div class="structured-fields-body">
									<div class="structured-fields-filter-wrap">
										<input
											v-model.trim="structuredFieldsFilter"
											type="text"
											class="structured-fields-filter"
											placeholder="Filtrar campos..."
										/>
									</div>
									<details class="fields-group" open>
										<summary>Campos simples ({{ groupedStructuredOptions.simple.length }})</summary>
										<div class="structured-fields-list">
											<button
												v-for="(option, index) in groupedStructuredOptions.simple"
												:key="`dynamic-simple-${index}-${option.content}`"
												type="button"
												class="structured-field-chip"
												:class="`structured-field-${option.tipo || 'string'}`"
												draggable="true"
												@dragstart="handleDragStartOption(option, $event)"
												@click="insertStructuredOption(option)"
											>
												<span>{{ option.name }}</span>
												<span class="structured-field-kind" :class="`structured-field-kind-${option.tipo || 'string'}`">
													{{ getStructuredOptionTypeLabel(option) }}
												</span>
											</button>
										</div>
									</details>

									<details class="fields-group" open v-if="groupedStructuredOptions.object.length">
										<summary>Objetos ({{ groupedStructuredOptions.object.length }})</summary>
										<div class="structured-fields-list">
											<button
												v-for="(option, index) in groupedStructuredOptions.object"
												:key="`dynamic-object-${index}-${option.content}`"
												type="button"
												class="structured-field-chip structured-field-object"
												draggable="true"
												@dragstart="handleDragStartOption(option, $event)"
												@click="insertStructuredOption(option)"
											>
												<span>{{ option.name }}</span>
												<span class="structured-field-kind" :class="`structured-field-kind-${option.tipo || 'string'}`">
													{{ getStructuredOptionTypeLabel(option) }}
												</span>
											</button>
										</div>
									</details>

									<details class="fields-group" open v-if="groupedStructuredOptions.list.length">
										<summary>Listas / Iteradores ({{ groupedStructuredOptions.list.length }})</summary>
										<div class="structured-fields-list">
											<button
												v-for="(option, index) in groupedStructuredOptions.list"
												:key="`dynamic-list-${index}-${option.content}`"
												type="button"
												class="structured-field-chip structured-field-list"
												draggable="true"
												@dragstart="handleDragStartOption(option, $event)"
												@click="insertStructuredOption(option)"
											>
												<span>{{ option.name }}</span>
												<span class="structured-field-kind" :class="`structured-field-kind-${option.tipo || 'string'}`">
													{{ getStructuredOptionTypeLabel(option) }}
												</span>
											</button>
										</div>
									</details>
								</div>
							</div>
						</div>
					</f7-list>
				</f7-card-content>
			</f7-card>
			<f7-popover
				:closeByBackdropClick="false"
				:backdrop="true"
				closeOnEscape
				ref="popover"
			>
				<f7-navbar :title="$t('SelecciÃ³n de campos del elemento')">
					<f7-nav-right>
					</f7-nav-right>
				</f7-navbar>
				<f7-list no-hairlines-md>
					<select @change="setOptionSelected">
						<option>Seleccione un campo...</option>
						<option v-for="(opcion,index) in opciones" :key="'select.opcion-'+index" :value="opcion.content">{{ opcion.name }}</option>
					</select>
				</f7-list>
			</f7-popover>
		</f7-page>
	</f7-popup>

  </div>
</template>

<style>
.popupedicion {
	width: min(96vw, 1650px);
	left: 50%;
	transform: translateX(-50%);
}

.main-editor-workspace {
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	gap: 12px;
	align-items: start;
}

.main-editor-workspace.has-context-panel {
	grid-template-columns: minmax(0, 1fr) minmax(300px, 340px);
}

.main-editor-zone {
	min-width: 0;
}

.main-context-panel {
	max-height: clamp(320px, 70vh, 760px);
	overflow: hidden;
	display: flex;
	flex-direction: column;
	position: sticky;
	top: 8px;
}

.main-context-body {
	min-height: 220px;
}

.main-context-header-right {
	display: flex;
	align-items: center;
	gap: 6px;
}

.context-debug-toggle {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	border-radius: 4px;
	border: 1px solid #c5d4ec;
	background: #edf3ff;
	color: #6b85b0;
	cursor: pointer;
	padding: 0;
	font-size: 11px;
	line-height: 1;
	transition: background 0.15s, color 0.15s;
}

.context-debug-toggle:hover {
	background: #d6e6ff;
	color: #2d4b7c;
}

.main-context-badge {
	font-size: 10px;
	font-weight: 700;
	padding: 3px 7px;
	border-radius: 999px;
	border: 1px solid #b4c7e6;
	background: #edf3ff;
	color: #2d4b7c;
	line-height: 1;
	white-space: nowrap;
}

.context-debug-panel {
	padding: 8px 10px;
	border-top: 1px solid #dbe5f2;
	border-bottom: 1px solid #dbe5f2;
	background: #f8fbff;
	font-size: 11px;
	color: #334a70;
	word-break: break-word;
}

.context-debug-title {
	font-weight: 700;
	margin-bottom: 4px;
	color: #22355b;
}

.context-debug-row {
	margin-bottom: 2px;
}

.valor-block {
	border: 1px dashed #1976d2;
	padding: 6px 8px;
	margin: 2px 0;
	background: rgba(25, 118, 210, 0.05);
	position: relative;
	display: inline-block;
}

.valor-block::before {
	display: block;
	font-size: 10px;
	font-weight: bold;
	color: #1976d2;
	margin-bottom: 4px;
	content: attr(data-block-label);
}

.valor-block-list::after {
	display: block;
	font-size: 10px;
	color: #5f6368;
	margin-top: 4px;
	content: "Separador: " attr(data-block-separator);
}

.valor-block-object {
	border-color: #2e7d32;
	background: rgba(46, 125, 50, 0.05);
}

.valor-block-object::before {
	color: #2e7d32;
}

.structured-fields-panel {
	padding: 0;
	border: 1px solid #d9e1ef;
	border-radius: 8px;
	background: #f7faff;
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.structured-workspace {
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	gap: 14px;
	margin-top: 5px;
	margin-left: 15px;
	margin-right: 15px;
	height: clamp(360px, 62vh, 700px);
	min-height: 320px;
	align-items: start;
}

.structured-workspace.has-panel {
	grid-template-columns: minmax(0, var(--editor-column, 64%)) 10px minmax(280px, var(--panel-column, 36%));
	gap: 10px;
}

.structured-workspace.is-resizing {
	user-select: none;
}

.structured-editor-zone {
	min-height: 280px;
	height: 100%;
	overflow: auto;
	padding-right: 6px;
}

.inline-structured-panel {
	height: 100%;
	max-height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.structured-column-resizer {
	width: 10px;
	height: 100%;
	cursor: col-resize;
	border-radius: 6px;
	background: linear-gradient(180deg, #d7e4f7 0%, #b9cde9 50%, #d7e4f7 100%);
	align-self: stretch;
}

.structured-column-resizer:hover {
	background: linear-gradient(180deg, #c9dbf5 0%, #8fb2e4 50%, #c9dbf5 100%);
}

.structured-fields-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 8px;
	padding: 10px;
	border-bottom: 1px solid #dbe5f2;
	background: #eef4fc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}

.structured-fields-title {
	font-size: 12px;
	font-weight: 700;
	color: #22355b;
	margin-bottom: 2px;
}

.structured-fields-help {
	font-size: 11px;
	color: #5f6368;
	margin-bottom: 0;
}

.structured-fields-body {
	flex: 1;
	min-height: 0;
	max-height: none;
	overflow: auto;
	padding: 8px 10px 10px;
}

.structured-editor-zone .ql-container {
	min-height: 250px;
}

.structured-editor-zone .ql-editor {
	min-height: 250px;
}

body.column-resize-active {
	cursor: col-resize !important;
	user-select: none;
}

.structured-fields-filter-wrap {
	position: sticky;
	top: 0;
	padding-bottom: 8px;
	margin-bottom: 6px;
	background: #f7faff;
	z-index: 1;
}

.structured-fields-filter {
	width: 100%;
	box-sizing: border-box;
	border: 1px solid #c6d5eb;
	border-radius: 6px;
	padding: 7px 10px;
	font-size: 12px;
	outline: none;
	background: #fff;
	color: #22355b;
}

.structured-fields-filter:focus {
	border-color: #1976d2;
	box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.15);
}

.fields-group {
	margin-bottom: 8px;
}

.fields-group summary {
	font-size: 11px;
	font-weight: 700;
	color: #334a70;
	cursor: pointer;
	margin-bottom: 6px;
}

.structured-fields-list {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.structured-field-chip {
	border: 1px solid #9bb3d8;
	background: #ffffff;
	color: #22355b;
	font-size: 11px;
	padding: 4px 8px;
	border-radius: 999px;
	cursor: grab;
	line-height: 1.2;
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

.structured-field-chip:active {
	cursor: grabbing;
}

.structured-field-list {
	border-color: #1976d2;
	background: #eef6ff;
}

.structured-field-object {
	border-color: #2e7d32;
	background: #edf8f1;
}

.structured-field-html {
	border-color: #795548;
	background: #f6efeb;
}

.structured-field-kind {
	font-size: 9px;
	font-weight: 700;
	line-height: 1;
	padding: 2px 6px;
	border-radius: 999px;
	border: 1px solid #b4c7e6;
	background: #edf3ff;
	color: #2d4b7c;
	letter-spacing: 0.2px;
}

.structured-field-kind-list {
	border-color: #8ab8eb;
	background: #e7f2ff;
	color: #0d4a8d;
}

.structured-field-kind-object {
	border-color: #9fd2b0;
	background: #e9f7ef;
	color: #1e6f3a;
}

.structured-field-kind-html {
	border-color: #d9b9a8;
	background: #f8efe9;
	color: #7a4a2d;
}

.structured-field-kind-string {
	border-color: #b4c7e6;
	background: #edf3ff;
	color: #2d4b7c;
}

.medium-editor-container [data-type="list"],
.medium-editor-container [data-type="object"] {
	border: 1px dashed #1976d2;
	border-radius: 4px;
	padding: 2px 6px;
	background: rgba(25, 118, 210, 0.08);
	position: relative;
	display: inline-block;
	min-height: 18px;
	vertical-align: baseline;
}

.medium-editor-container [data-type="object"] {
	border-color: #2e7d32;
	background: rgba(46, 125, 50, 0.08);
}

.medium-editor-container [data-type="list"]::before,
.medium-editor-container [data-type="object"]::before {
	content: "ITERADOR";
	position: absolute;
	top: -11px;
	left: 4px;
	font-size: 9px;
	font-weight: 700;
	line-height: 1;
	padding: 1px 4px;
	border-radius: 3px;
	background: #1976d2;
	color: #fff;
}

.medium-editor-container [data-type="object"]::before {
	content: "OBJETO";
	background: #2e7d32;
}

.medium-editor-container [data-type="list"]:empty::after,
.medium-editor-container [data-type="object"]:empty::after {
	content: "[contenido dinÃ¡mico]";
	font-size: 11px;
	color: #607d8b;
}

.medium-editor-container .medium-editor-element br,
.structured-editor-zone .ql-editor br {
	display: block;
	position: relative;
	line-height: 1.2;
	height: 1.2em;
}

.medium-editor-container .medium-editor-element br::after,
.structured-editor-zone .ql-editor br::after {
	content: "↵";
	position: absolute;
	left: 6px;
	top: 0;
	font-size: 10px;
	font-weight: 700;
	line-height: 1.2;
	color: #8aa1bd;
	background: #eef4fb;
	border: 1px dashed #bfd0e6;
	border-radius: 999px;
	padding: 0 5px;
	pointer-events: none;
}

@media (max-width: 1180px) {
	.main-editor-workspace.has-context-panel {
		grid-template-columns: 1fr;
	}

	.main-context-panel {
		position: static;
		max-height: 320px;
	}

	.popupedicion {
		width: 98vw;
	}

	.structured-workspace {
		grid-template-columns: 1fr;
		height: auto;
	}

	.inline-structured-panel {
		max-height: 320px;
	}

	.structured-column-resizer {
		display: none;
	}
}
</style>

<script>
import BaseMediumEditor from './rMediumEditor.vue';
import ValorEntidadBlock from './extensions/ValorEntidadBlock';
import mainEditorStructuredContextMixin from './mainEditorStructuredContextMixin';
import {
	buildInsertionContent,
	buildScopedOptions,
	buildStructuredDefaultInnerHTML,
	groupOptionsByType,
	isStructuredType,
	joinStructuredPath,
	replaceRelativePrefix
} from './structuredEditorUtils';
import LineaPedido from '../../js/db/LineaPedido.js';
import Oferta from '../../js/db/Oferta.js';
import Oportunidad from '../../js/db/Oportunidad.js';
import Factura from '../../js/db/Factura.js';
import Tarea from '../../js/db/Tarea';

export default {
	name: 'rMediumEditorBlock',
	extends: BaseMediumEditor,
	mixins: [mainEditorStructuredContextMixin],
	data() {
		return {
			definitionRootProperties: [],
			structuredDefinitionTree: null,
			draggedStructuredOption: null,
			structuredFieldsFilter: '',
			editorColumnPercent: 64,
			columnResizeState: null,
			isColumnResizing: false,
			showContextDebug: false
		};
	},
	computed: {
		columnWidthStorageKey() {
			const templateName = this.data && this.data.name ? this.data.name : 'default';
			return `rMediumEditorBlock:editorColumnPercent:${templateName}`;
		},
		structuredWorkspaceStyle() {
			if (!this.hasStructuredInnerHTMLOptions) {
				return null;
			}

			const clampedEditor = Math.max(35, Math.min(78, this.editorColumnPercent));
			const panelPercent = 100 - clampedEditor;
			return {
				'--editor-column': `${clampedEditor}%`,
				'--panel-column': `${panelPercent}%`
			};
		},
		hasStructuredInnerHTMLOptions() {
			return this.structuredInnerHTMLOptions.length > 0;
		},
		groupedStructuredOptions() {
			return groupOptionsByType(this.filteredStructuredOptions);
		},
		filteredStructuredOptions() {
			const filter = (this.structuredFieldsFilter || '').toLowerCase();
			if (!filter) {
				return this.structuredInnerHTMLOptions;
			}

			return this.structuredInnerHTMLOptions.filter(option => {
				const name = (option.name || '').toLowerCase();
				const content = (option.content || '').toLowerCase();
				return name.includes(filter) || content.includes(filter);
			});
		},
		structuredInnerHTMLOptions() {
			const inner = this.objetoActual && this.objetoActual.properties ? this.objetoActual.properties.innerHTML : null;
			const options = inner && inner.opciones ? inner.opciones : [];
			return Array.isArray(options) ? options : [];
		}
	},
	created() {
		if (this.tipo === 'templates/mail/' && this.options && this.options.extensions) {
			this.options.extensions.valor = new ValorEntidadBlock();
		}
	},
	mounted() {
		this.restoreColumnWidthPreference();

		if (this.tipo === 'templates/mail/') {
			this.loadStructuredDefinitions();
		}
	},
	beforeDestroy() {
		this.stopColumnResize();
	},
	methods: {
		getStructuredOptionTypeLabel(option) {
			if (!option || !option.tipo) {
				return 'CAMPO';
			}

			if (option.tipo === 'list') {
				return 'ITERADOR';
			}

			if (option.tipo === 'object') {
				return 'OBJETO';
			}

			if (option.tipo === 'html') {
				return 'HTML';
			}

			return 'CAMPO';
		},

		restoreColumnWidthPreference() {
			try {
				const storedValue = window.localStorage.getItem(this.columnWidthStorageKey);
				if (storedValue === null) {
					return;
				}

				const parsed = Number(storedValue);
				if (!Number.isNaN(parsed)) {
					this.editorColumnPercent = Math.max(35, Math.min(78, parsed));
				}
			} catch (error) {
				console.warn('No se ha podido recuperar el ancho de columnas guardado.', error);
			}
		},

		persistColumnWidthPreference() {
			try {
				window.localStorage.setItem(this.columnWidthStorageKey, String(this.editorColumnPercent));
			} catch (error) {
				console.warn('No se ha podido guardar el ancho de columnas.', error);
			}
		},

		handlePopupClose() {
			this.stopColumnResize();
			this.popupEdicionShow = false;
		},

		startColumnResize(event) {
			if (window.matchMedia('(max-width: 1180px)').matches) {
				return;
			}

			const workspace = this.$el ? this.$el.querySelector('.structured-workspace.has-panel') : null;
			if (!workspace) {
				return;
			}

			const rect = workspace.getBoundingClientRect();
			this.columnResizeState = {
				startX: event.clientX,
				startPercent: this.editorColumnPercent,
				width: rect.width
			};
			this.isColumnResizing = true;
			document.body.classList.add('column-resize-active');
			document.addEventListener('mousemove', this.onColumnResize);
			document.addEventListener('mouseup', this.stopColumnResize);
		},

		onColumnResize(event) {
			if (!this.columnResizeState || !this.columnResizeState.width) {
				return;
			}

			const deltaX = event.clientX - this.columnResizeState.startX;
			const deltaPercent = (deltaX / this.columnResizeState.width) * 100;
			this.editorColumnPercent = Math.max(35, Math.min(78, this.columnResizeState.startPercent + deltaPercent));
		},

		stopColumnResize() {
			if (this.columnResizeState) {
				this.persistColumnWidthPreference();
			}

			this.columnResizeState = null;
			this.isColumnResizing = false;
			document.body.classList.remove('column-resize-active');
			document.removeEventListener('mousemove', this.onColumnResize);
			document.removeEventListener('mouseup', this.stopColumnResize);
		},

		insertStructuredOption(option) {
			const content = buildInsertionContent(option, true);
			if (!content) {
				return;
			}
			this.insertDynamicContentAtSelection(content.html, content.text);
		},

		handleDragStartOption(option, event) {
			this.draggedStructuredOption = option;
			if (!event || !event.dataTransfer) {
				return;
			}
			event.dataTransfer.effectAllowed = 'copy';
			event.dataTransfer.setData('text/plain', JSON.stringify(option));
		},

		handleDropOnDynamicEditor(event) {
			let option = this.draggedStructuredOption;
			if (!option && event && event.dataTransfer) {
				const raw = event.dataTransfer.getData('text/plain');
				if (raw) {
					try {
						option = JSON.parse(raw);
					} catch (error) {
						option = null;
					}
				}
			}
			if (option) {
				this.insertStructuredOption(option);
			}
			this.draggedStructuredOption = null;
		},

		isAbsoluteStructuredPath(path) {
			if (!path) {
				return false;
			}
			const firstChunk = path.split('.')[0];
			return this.definitionRootProperties.includes(firstChunk);
		},

		resolveMailDefinitionModel() {
			let modelo = LineaPedido;
			if (this.data && this.data.name && this.data.name.endsWith('_oportunidad')) {
				modelo = Oportunidad;
			} else if (this.data && this.data.name && this.data.name.endsWith('_oferta')) {
				modelo = Oferta;
			} else if (this.data && this.data.name && this.data.name.endsWith('_tarea')) {
				modelo = Tarea;
			} else if (this.data && this.data.name && this.data.name.endsWith('_factura')) {
				modelo = Factura;
			}
			return modelo;
		},

		loadStructuredDefinitions() {
			const modelo = this.resolveMailDefinitionModel();
			if (!modelo || typeof modelo.define !== 'function') {
				return;
			}

			modelo.define().then(definitionTree => {
				const valor = this.$refs.mediumeditor && this.$refs.mediumeditor.editor
					? this.$refs.mediumeditor.editor.options.extensions.valor
					: null;
				this.definitionRootProperties = (definitionTree && definitionTree.children ? definitionTree.children : []).map(child => child.property);
				if (valor && valor.loadDefinitionTree) {
					valor.loadDefinitionTree(definitionTree);
					this.structuredDefinitionTree = valor.definitionTree;
				}
				this.updateMainEditorContextFromSelection();
			}).catch(error => {
				console.warn('No se ha podido cargar la definiciÃ³n estructurada del editor de bloques.', error);
			});
		},

		getValor(valor) {
			const lookupPath = this.normalizeDefinitionLookupPath ? this.normalizeDefinitionLookupPath(valor) : valor;
			const valorEntidad = this.$refs.mediumeditor.editor.options.extensions.valor;
			if (valorEntidad && typeof valorEntidad.getDefinitionNode === 'function') {
				return valorEntidad.getDefinitionNode(lookupPath);
			}
			return BaseMediumEditor.methods.getValor.call(this, lookupPath);
		},

		findDefinitionByPath(path) {
			const lookupPath = this.normalizeDefinitionLookupPath ? this.normalizeDefinitionLookupPath(path) : path;
			if (!lookupPath || !this.structuredDefinitionTree) {
				return null;
			}

			const matchNode = (node) => {
				if (!node) return null;
				if (node.path === lookupPath || node.property === lookupPath) {
					return node;
				}
				if (node.children && node.children.length) {
					for (const child of node.children) {
						const found = matchNode(child);
						if (found) return found;
					}
				}
				return null;
			};

			if (Array.isArray(this.structuredDefinitionTree)) {
				for (const node of this.structuredDefinitionTree) {
					const found = matchNode(node);
					if (found) return found;
				}
				return null;
			}

			return matchNode(this.structuredDefinitionTree);
		},

		insertDynamicContentAtSelection(html, fallbackText) {
			const selection = window.getSelection();
			if (!selection || !selection.rangeCount) {
				this.property.valor = `${this.property.valor || ''}${fallbackText || html}`;
				return;
			}

			const range = selection.getRangeAt(0);
			range.deleteContents();
			const fragment = range.createContextualFragment(`${html}&nbsp;`);
			const lastNode = fragment.lastChild;
			range.insertNode(fragment);
			if (lastNode) {
				range.setStartAfter(lastNode);
				range.collapse(true);
				selection.removeAllRanges();
				selection.addRange(range);
			}
		},

		setOptionSelected(event) {
			const valor = event.target.options[event.target.options.selectedIndex].value;
			const opcion = this.opciones.find(op => op.content === valor);
			if (!opcion) {
				return;
			}

			if (this.property.tipo === 'innerHTML') {
				this.insertStructuredOption(opcion);
			} else {
				this.property.valor = valor;
			}

			this.opciones = false;
			this.$refs.popover.close(this.objetoActual.event.target);
		},

		edit(objeto) {
			BaseMediumEditor.methods.edit.call(this, objeto);

			if (!this.item) {
				return;
			}

			const itemType = this.item.getAttribute('data-type');
			if (!isStructuredType(itemType)) {
				return;
			}

			const definitionPath = this.resolveDefinitionPathForElement(this.item);
			const definition = this.getValor(definitionPath);
			if (!definition) {
				return;
			}

			if (!this.objetoActual.properties.attributes) {
				this.$set(this.objetoActual.properties, 'attributes', {});
			}

			['data-type', 'data-type-value', 'data-condition'].forEach(attributeName => {
				if (!this.objetoActual.properties.attributes[attributeName]) {
					this.$set(this.objetoActual.properties.attributes, attributeName, {
						opciones: null,
						valor: this.item.getAttribute(attributeName),
						tipo: 'attribute'
					});
				}
			});

			if (itemType === 'list' && !this.objetoActual.properties.attributes['data-recursive-field']) {
				this.$set(this.objetoActual.properties.attributes, 'data-recursive-field', {
					opciones: buildScopedOptions(definition).filter(option => option.tipo === 'list'),
					valor: this.item.getAttribute('data-recursive-field'),
					tipo: 'attribute'
				});
			}

			if (itemType === 'list' && !this.objetoActual.properties.attributes['data-block-separator']) {
				this.$set(this.objetoActual.properties.attributes, 'data-block-separator', {
					opciones: null,
					valor: this.item.getAttribute('data-block-separator') || ', ',
					tipo: 'attribute'
				});
			}

			this.objetoActual.properties.innerHTML = {
				opciones: buildScopedOptions(definition),
				valor: this.item.innerHTML ? this.item.innerHTML : buildStructuredDefaultInnerHTML(definition),
				tipo: 'innerHTML',
				scopePath: definition.path,
				structuredType: itemType
			};
		},

		applyObjectContext(node, prefix) {
			const childNodes = Array.from(node.childNodes || []);
			childNodes.forEach(child => {
				if (child.nodeType === Node.TEXT_NODE) {
					child.textContent = replaceRelativePrefix(child.textContent, prefix, this.definitionRootProperties);
					return;
				}

				if (child.nodeType !== Node.ELEMENT_NODE) {
					return;
				}

				const childType = child.getAttribute('data-type');
				if (childType === 'list') {
					const currentValue = child.getAttribute('data-type-value');
					if (currentValue
						&& !this.definitionRootProperties.includes(currentValue.split('.')[0])
						&& !currentValue.startsWith('$')
						&& currentValue !== prefix
						&& !currentValue.startsWith(prefix + '.')) {
						child.setAttribute('data-type-value', joinStructuredPath(prefix, currentValue));
					}
					return;
				}

				if (childType === 'object') {
					const currentObjectValue = child.getAttribute('data-type-value');
					const alreadyPrefixed = currentObjectValue && (
						currentObjectValue === prefix || currentObjectValue.startsWith(prefix + '.')
					);
					const nextPrefix = currentObjectValue
						&& !this.definitionRootProperties.includes(currentObjectValue.split('.')[0])
						&& !currentObjectValue.startsWith('$')
						&& !alreadyPrefixed
						? joinStructuredPath(prefix, currentObjectValue)
						: currentObjectValue;
					if (nextPrefix) {
						child.setAttribute('data-type-value', nextPrefix);
						this.applyObjectContext(child, nextPrefix);
					}
					return;
				}

				Array.from(child.attributes || []).forEach(attribute => {
					if (attribute.name === 'data-type-value' || attribute.name === 'data-recursive-field') {
						return;
					}
					attribute.value = replaceRelativePrefix(attribute.value, prefix, this.definitionRootProperties);
				});

				this.applyObjectContext(child, prefix);
			});
		},

		unwrapNode(node) {
			if (!node || !node.parentNode) {
				return;
			}
			while (node.firstChild) {
				node.parentNode.insertBefore(node.firstChild, node);
			}
			node.parentNode.removeChild(node);
		},

		normalizeStructuredBlocks(doc) {
			const structuredBlocks = Array.from(doc.querySelectorAll('[data-type="object"], [data-type="list"]'))
				.filter(block => {
					const parentStructuredBlock = block.parentElement
						? block.parentElement.closest('[data-type="object"], [data-type="list"]')
						: null;
					return !parentStructuredBlock;
				});

			structuredBlocks.forEach(block => {
				let prefix = block.getAttribute('data-type-value');
				// Normalizar prefijo root para bloques en nivel raiz que no lo tengan
				if (prefix && prefix.indexOf('$') !== 0) {
					prefix = '$root.' + prefix;
					block.setAttribute('data-type-value', prefix);
				}
				// Solo los bloques objeto raiz normalizan sus tokens de campo internos.
				// Los bloques lista establecen su propio contexto de iteracion con $actual.
				if (block.getAttribute('data-type') !== 'object') {
					return;
				}
				if (prefix) {
					this.applyObjectContext(block, prefix);
				}
			});
		},

		getContent() {
			const contenidoRaw = this.$refs.mediumeditor.editor.getContent();
			let watermarked = false;
			let provisional = false;
			let top = 0;
			let bottom = 0;

			if (this.tipo === 'templates/EXPEDIENTES/') {
				watermarked = this.$refs.mediumeditor.editor.options.extensions.watermark.isWatermarked();
				provisional = this.$refs.mediumeditor.editor.options.extensions.provisional.isProvisional();
				top = this.$refs.mediumeditor.editor.options.extensions.cabecera.cabeceraSize();
				bottom = this.$refs.mediumeditor.editor.options.extensions.pie.pieSize();
			} else if (this.tipo === 'templates/OFERTAS/') {
				top = this.$refs.mediumeditor.editor.options.extensions.cabecera.cabeceraSize();
				bottom = this.$refs.mediumeditor.editor.options.extensions.pie.pieSize();
			}

			const doc = new DOMParser().parseFromString(contenidoRaw, 'text/html');
			if (this.tipo === 'templates/mail/') {
				this.normalizeStructuredBlocks(doc);
			}
			let xhtmlDoc = new XMLSerializer().serializeToString(doc);
			xhtmlDoc = this._manageBodyClasses(xhtmlDoc, watermarked, provisional);
			xhtmlDoc = this._manageMargins(xhtmlDoc, top, bottom);
			return xhtmlDoc;
		}
	}
};
</script>
